import { render } from "./pageBanner.vue?vue&type=template&id=bb6d67cc&scoped=true"
import script from "./pageBanner.vue?vue&type=script&lang=js"
export * from "./pageBanner.vue?vue&type=script&lang=js"

import "./pageBanner.vue?vue&type=style&index=0&id=bb6d67cc&lang=less&scoped=true"

import exportComponent from "/Users/shixiaolong/Desktop/code/海玛_EN/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6d67cc"]])

export default __exports__